import request from '../untils/request.js'
// 新闻热点
export const mapNum = data => {
        return request({
            method: 'POST',
            url: '/lsg-bigscreen/newsMap/getLocalCode',
            data
        })
    }
    // 新闻地区
export const mapTime = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/newsMap/getNewsCount',
            params
        })
    }
    // 全疆新闻地图 新版 付
export const mapMon = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/newsMap/getNewsByCity',
            params
        })
    }
    // 全疆新闻地图 老版 前辈
export const mapNew = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/localNews/getLocalNews',
            // url: '/lsg-bigscreen/localNews/getXjNews',
            params
        })
    }
    // 全疆新闻地图  酒泉
export const getLocalNewsByKeyword = params => {
        return request({
            method: 'GET',
            url: '/lsg-bigscreen/localNews/getLocalNewsByKeyword',
            params
        })
    }
    // 全国热点交通
export const trapic = () => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/groupNews/getRealtimeTraffic',
    })
}

// 本地最新新闻
export const tipCont = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/newsMap/getNewsByCity',
        params
    })
}